import React, { createContext, useContext, useState, ReactNode } from 'react';

// Define the shape of the breadcrumb item
export interface BreadcrumbItem {
  title: string;
  path: string;
}

// Define the shape of the context state and the update function
interface BreadcrumbContextType {
  path: BreadcrumbItem[];
  setPath: (newPath: BreadcrumbItem[]) => void;
  isShow: boolean;
  setIsShow: (show: boolean) => void;
}

// Create the context with default values
const BreadcrumbContext = createContext<BreadcrumbContextType | undefined>(undefined);

// Custom hook for consuming the context (easiest way to use it)
export const useBreadcrumb = () => {
  const context = useContext(BreadcrumbContext);
  if (context === undefined) {
    throw new Error('useBreadcrumb must be used within a BreadcrumbProvider');
  }
  return context;
};

// Provider component that wraps your entire application (or MainLayout)
interface BreadcrumbProviderProps {
  children: ReactNode;
}

export const BreadcrumbProvider: React.FC<BreadcrumbProviderProps> = ({ children }) => {
  const [path, setPath] = useState<BreadcrumbItem[]>([]);
  const [isShow, setIsShow] = useState<boolean>(true);

  return (
    <BreadcrumbContext.Provider value={{ path, setPath, isShow, setIsShow }}>
      {children}
    </BreadcrumbContext.Provider>
  );
};